import React from 'react';
import { motion } from 'framer-motion';
export function EliteExplainer() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-light-green py-20 px-4" data-id="element-76">
      <div className="max-w-5xl mx-auto" data-id="element-77">
        <div className="text-center mb-16" data-id="element-78">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl md:text-3xl font-bold text-deep-green mb-4" data-id="element-79">
            🔥 ¿Por qué el Pack Elite a $27.990 es mejor negocio que el de
            $18.990?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-600" data-id="element-80">
            Por $10.000 más (el precio de dos pizzas) te llevás esto:
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-81">
          {/* ELITE CARD 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl shadow-md border border-gray-100 border-l-4 border-l-gold p-8" data-id="element-82">
            <div className="inline-block bg-gold/20 text-gold-700 text-xs font-bold px-3 py-1 rounded-full mb-4" data-id="element-83">
              💎 EBOOK ELITE 1
            </div>
            <h3 className="text-xl font-bold text-deep-green mb-4" data-id="element-84">
              Método Viajero Express
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed mb-6" data-id="element-85">
              El curso de 4 clases listo para vender a cualquier alumno que
              viaje a Brasil. Guion de venta incluido, materiales para el
              alumno, cheat sheet imprimible y certificado de finalización.
            </p>
            <div className="bg-gold/10 border border-gold/30 rounded-lg p-4" data-id="element-86">
              <p className="text-deep-green font-bold text-sm" data-id="element-87">
                → Podés cobrar $20.000 por 4 clases desde mañana mismo.
              </p>
            </div>
          </motion.div>

          {/* ELITE CARD 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-xl shadow-md border border-gray-100 border-l-4 border-l-gold p-8" data-id="element-88">
            <div className="inline-block bg-gold/20 text-gold-700 text-xs font-bold px-3 py-1 rounded-full mb-4" data-id="element-89">
              💎 EBOOK ELITE 2
            </div>
            <h3 className="text-xl font-bold text-deep-green mb-4" data-id="element-90">
              Corrección Automática Pro
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed mb-6" data-id="element-91">
              Exámenes espejo que se corrigen en 60 segundos, rúbricas de tilde,
              banco de feedback copy-paste y sistema de autocorrección guiada
              para el alumno.
            </p>
            <div className="bg-gold/10 border border-gold/30 rounded-lg p-4" data-id="element-92">
              <p className="text-deep-green font-bold text-sm" data-id="element-93">
                → Pasás de 17 horas de corrección mensual a menos de 3.
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto" data-id="element-94">
          <p className="text-xl font-bold text-deep-green mb-8 leading-relaxed" data-id="element-95">
            Con el Pack Completo tenés material para dar clase.
            <br data-id="element-96" />
            Con el Pack Elite tenés material para dar clase Y un sistema para
            ganar más dinero y trabajar menos.
          </p>

          <button onClick={scrollToPricing} className="w-full md:w-auto bg-gold hover:bg-yellow-500 text-deep-green font-extrabold text-lg py-4 px-10 rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-97">
            → SÍ, QUIERO EL PACK ELITE — $27.990
          </button>
        </motion.div>
      </div>
    </section>;
}